import { render, staticRenderFns } from "./im_new.vue?vue&type=template&id=040483a8&scoped=true&"
import script from "./im_new.vue?vue&type=script&lang=ts&"
export * from "./im_new.vue?vue&type=script&lang=ts&"
import style0 from "./im_new.vue?vue&type=style&index=0&id=040483a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040483a8",
  null
  
)

export default component.exports